module.exports = __webpack_public_path__ + "static/media/Body-Front v2.3a9d0186.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Body-Front v2.png
// module id = 1173
// module chunks = 0